import { render, staticRenderFns } from "./DiscussDetail.vue?vue&type=template&id=e30d92f8&scoped=true"
import script from "./DiscussDetail.vue?vue&type=script&lang=js"
export * from "./DiscussDetail.vue?vue&type=script&lang=js"
import style0 from "./DiscussDetail.vue?vue&type=style&index=0&id=e30d92f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e30d92f8",
  null
  
)

export default component.exports